__turbopack_context__.v({
  "className": "cormorant_garamond_85264c51-module__BVgcga__className",
});
